import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@enviroment/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-video-frame',
  templateUrl: './modal-video-frame.component.html',
  styleUrl: './modal-video-frame.component.css'
})
export class ModalVideoFrameComponent implements OnInit  {

  data:any;
  env = environment;
  link: string = '';
  safeUrl!: SafeResourceUrl;

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.link = this.env.S3_STATIC_FILES + this.data.link;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.link);
  }


}
